import React from "react";
import "./App.scss";
import {
  fetchAirlineLinks,
  fetchConfig,
  FetchConfigProps,
} from "./features/config/ConfigActions";
import { Helmet } from "react-helmet-async";
import Loading from "./Loading";
import MTT12 from "./layouts/MTT12";
import MOT12 from "./layouts/MOT12";
import MOB12 from "./layouts/MOB12";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import useResizeObserver from "@react-hook/resize-observer";
import { fvaxSignal } from "./config/AccessEvent";
import ITT from "./layouts/ITT";
import CopyToClipboardButton from "./features/searchFlights/results/CopyToClipboardButton";
import SFO from "./layouts/custom/SFO";

const FLOAT = React.lazy(() => import("./layouts/FLOAT"))

function App({ accCustId }) {
  const dispatch = useAppDispatch();
  const { title, lfMain } = useAppSelector((state) => state.config.app);
  const { loaded, unknown } = useAppSelector((state) => state.config);
  useResizeObserver(document.body, () =>
    fvaxSignal("resize", "custId", "toolId")
  );

  React.useEffect(() => {
    dispatch(
      fetchConfig({
        configPath: accCustId,
      } as FetchConfigProps)
    ).then((response) => {
      if (
        response.payload &&
        response.payload.MapperCustom.includeAirlineLinks
      ) {
        dispatch(fetchAirlineLinks());
      }
    });
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {unknown && <div>No accCustId specified, or config invalid.</div>}
      {!unknown && (
        <>
          <Loading loading={!loaded} />
          {loaded && (
            <div id="layout" className={lfMain === "FLOAT" ?"" : "p-2"}>
              {lfMain === "MTT12" && <MTT12 />}
              {lfMain === "MOT12" && <MOT12 />}
              {lfMain === "MOB12" && <MOB12 />}
              {lfMain === "ITT" && <ITT />}
              {lfMain === "SFO" && <SFO />}
              {lfMain === "FLOAT" && <FLOAT />}
            </div>
          )}
        </>
      )}
      <CopyToClipboardButton />
    </>
  );
}

export default App;
